import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GeneratedClientManagerService } from '../generated-client-manager.service';
import { WorkOrderClient, WorkOrderElementResponseDto } from '../simulation.generated.client';

@Injectable()
export class WorkOrdersElementService extends GeneratedClientManagerService {
  private _client: WorkOrderClient;

  constructor() {
    super();
    this._client = new WorkOrderClient(this.httpClient, this.baseUrl);
  }

  getWorkOrdersByExecution(executionId: string): Observable<WorkOrderElementResponseDto[]> {
    const context = this.buildHttpContext();
    return this._client.getWorkOrdersByElement(executionId, context);
  }

  getWorkOrdersByElement(networkElementId: string): Observable<WorkOrderElementResponseDto[]> {
    const context = this.buildHttpContext();
    return this._client.getWorkOrdersByElement(networkElementId, context);
  }
}
